var map = {
	"./Caffezo/1.png": 30,
	"./Management/1.png": 2949,
	"./PocketLinks/1.png": 187,
	"./SiPattina/1.png": 4843,
	"./church/1.png": 8793,
	"./modern3d/1.png": 5520,
	"./nmoney/1.png": 1330,
	"./tozbest/1.png": 1563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;